import { FC, memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { TooltipSection } from "../constants";

interface IntentTooltipContentProps {
  sections: TooltipSection[];
  maxWidth?: number;
}

export const IntentTooltipContent: FC<IntentTooltipContentProps> = memo(
  ({ sections, maxWidth = 300 }) => (
    <Box sx={{ maxWidth }}>
      {sections.map((section, idx) => (
        <Box key={section.title} sx={{ mt: idx === 0 ? 0 : 1 }}>
          <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
            {section.title}
          </Typography>
          {section.description && (
            <Typography variant="body2" color="text.secondary">
              {section.description}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  )
);

IntentTooltipContent.displayName = "IntentTooltipContent";
